import createVueComponent from '../createVueComponent';

const CircleSlash = createVueComponent('CircleSlashIcon', [
  ['line', { x1: '9', x2: '15', y1: '15', y2: '9', key: '1dfufj' }],
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
]);

export default CircleSlash;
